import React from "react";
import Navbar from "./global-components/navbar-v2";
import Banner from "./section-components/banner-v2";
import Trending from "./section-components/trending-v3";
import NewsLatter from "./section-components/newsletter";
import TrendingV5 from "./section-components/trending-v5";
import Footer_v1 from "./global-components/footer";
import Suvichar from "./section-components/Suvichar";
import Podcast from "./section-components/podcast";

const Home_V2 = () => {
  return (
    <div>

      <Navbar />
      <Suvichar />
      {/* <Podcast /> */}
      <Banner />
      <Trending />
      {/* <TrendingV4 /> */}
      {/* <Catv2 /> */}
      <NewsLatter />
      {/* <VideoV3 /> */}
      {/* <Ads /> */}
      <TrendingV5 />
      <Footer_v1 />
    </div>
  );
};

export default Home_V2;
